export default "__VITE_ASSET__BDa92ChE__"